module.exports = __webpack_public_path__ + "static/media/none.7a57c039.png";